
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 58 58"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M50.949 12.187l-.771-.771L40.084 1.321l-.001-.001-.768-.768A1.891 1.891 0 0037.985 0H8.963C7.777 0 6.5.916 6.5 2.926V56c0 .838.843 1.654 1.839 1.91.05.013.097.032.148.042.157.031.316.048.476.048h40.074c.16 0 .319-.017.475-.048.052-.01.1-.029.15-.042.996-.257 1.838-1.072 1.838-1.91V13.978c0-.766-.092-1.332-.551-1.791zM39.5 3.565L47.935 12H39.5V3.565zM8.963 56c-.071 0-.135-.025-.198-.049a.46.46 0 01-.265-.414V41h41v14.537c0 .183-.11.339-.265.414-.063.024-.127.049-.198.049H8.963zM8.5 39V2.926c0-.217.033-.926.463-.926h28.595a1.54 1.54 0 00-.058.392V14h11.608c.135 0 .265-.025.391-.058l.001.036V39h-41z"}}),_c('path',{attrs:{"d":"M20.889 43.938L17.361 54h1.709l.738-2.092h3.787L24.32 54h1.695l-3.5-10.063h-1.626zm-.698 6.863l1.518-4.348 1.49 4.348h-3.008zM31.908 52.619l-2.338-8.695h-1.873l3.131 10.131h2.133l3.281-10.131h-1.859zM38.32 43.924h1.668V54H38.32zM36.037 21.156l-11-7a1.005 1.005 0 00-1.019-.033A1.002 1.002 0 0023.5 15v14a1.001 1.001 0 001.537.844l11-7a1.002 1.002 0 000-1.688zM25.5 27.179V16.821L33.637 22 25.5 27.179z"}})])])
          )
        }
      }
    